<template>
  <div class="locale-changer">
    <v-select
      :items="langs"
      v-model="$i18n.locale"
      menu-props="auto"
      label="Select"
      hide-details
      prepend-icon="map"
      single-line
      item-text="name"
      item-value="value"
      @change="setLocale()"
    />
  </div>
</template>

<script>
export default {
  name: 'LocaleChanger',
  data () {
    return { langs: [
      {
        value: 'da',
        name: 'Dansk'
      },
      {
        value: 'en',
        name: 'English'
      }
      ]
    }
  },
  methods: {
      setLocale: function () {
        this.$cookie.set('locale', this.$i18n.locale)
      },
  }
}
</script>